/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2025
///                                   RXO Inc.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of RXO Inc. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import Alert from "../../Alert";
import UploadLanesModal from "../pricing/UploadLanesModal";
import { fetchBidSummary } from "../../../slices/bidSummarySlice";
import { postImportAwards, postImportAwardsV2 } from "../../../api/lanes";
import messages from "../../../helpers/messages";

function AwardImportModal({ bidId, user, handleAwardImportModalClose }) {
  const dispatch = useDispatch();
  const route = useLocation().pathname.split("/")[3] || "";
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const { role, division } = user;
  const { useImportAwardsV2Endpoint } = useSelector(
    state => state.featureFlags
  );

  const handleSuccessModalClose = () => {
    setOpenSuccessModal(false);
    dispatch(
      fetchBidSummary({
        bidId,
        role,
        fetchTLLaneCount: true,
        division,
        fetchLanes: route === "pricing",
        clearFilterAndSortDetails: true,
        shouldFetchMatchingLanes: true
      })
    );
    handleAwardImportModalClose(true);
  };

  return (
    <>
      {!openSuccessModal && (
        <UploadLanesModal
          bidId={bidId}
          handleClose={handleAwardImportModalClose}
          role={role}
          division={division}
          modalTitle={messages.awardImport.defaultMessage}
          modalMessage={
            messages.selectTheCoyoteFormattedShipperAwardDocument.defaultMessage
          }
          uploadApi={
            useImportAwardsV2Endpoint ? postImportAwardsV2 : postImportAwards
          }
          showOnSuccessModal={false}
          onSuccess={() => setOpenSuccessModal(true)}
          uploadButtonCaption={messages.import.defaultMessage}
          validationMessage={
            messages.awardImportValidationMessage.defaultMessage
          }
        />
      )}
      {openSuccessModal && (
        <Alert
          title={
            useImportAwardsV2Endpoint
              ? messages.processing.defaultMessage
              : messages.success.defaultMessage
          }
          message={
            useImportAwardsV2Endpoint
              ? messages.awardImportInProgressModalMessage.defaultMessage
              : messages.awardImportSuccessMesssage.defaultMessage
          }
          handleClose={handleSuccessModalClose}
          singleButtonCaption={
            useImportAwardsV2Endpoint
              ? messages.close.defaultMessage
              : messages.done.defaultMessage
          }
          large={true}
        />
      )}
    </>
  );
}

export default AwardImportModal;
